import './jquery-global';
import Circles from './circles.min';
import '../../../../../bower_components/bootstrap-sass/assets/javascripts/bootstrap';


var lastScrollTop = 0;
$(window).scroll(function(event){
    var st = $(this).scrollTop();
    if (st > 10){
        // downscroll code
        console.log('down', st)
        $('.navbar-default').addClass('navbar-scale');
    } else {
        // upscroll code
        console.log('up', st)
        $('.navbar-default').removeClass('navbar-scale');
    }
    lastScrollTop = st;
});

$(document).ready(function(){
    $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function(){
        $(this).toggleClass('open');
    });
});


//target blank to external links
let links = document.links;
$(document.links).filter(function() {
    return this.hostname != window.location.hostname;
}).attr('target', '_blank');

//Bootstrap carousel
$('.carousel').carousel({
    interval: 3000
});

$(window).load(function() {
    // Animate loader off screen
    $(".loader-wrapper").fadeOut("slow");
    // $('#filesTable').removeClass('table-blur')
});

$("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
});

// Add 'spinners' for forms that should be submitted only once.
$('.submitspinner').on('submit.spinner', function () {
    $(this).find('button[type=submit]').addClass('disabled').blur();
    $(this).find('button[type=submit] i').addClass('icon-animate icon-spinner');
    console.log('sub')
    // Timeout of 10 seconds. The action really should have finished by now. Otherwise,
    // just let the user try again.
    window.setTimeout(function (self){
        $(self).removeClass('disabled');
        $(self).find('i').removeClass('icon-animate icon-spinner');
    }, 10000, $(this).find('button[type=submit]'));
});

function openChevron(e) {
    $(e.target)
        .prev('.panel-heading')
        .find('i')
        .css('transform','rotate(180deg');
}
function closeChevron(e) {
    $(e.target)
        .prev('.panel-heading')
        .find('i')
        .css('transform','rotate(0deg');
}
$('#accordion').on('hidden.bs.collapse', closeChevron);
$('#accordion').on('shown.bs.collapse', openChevron);
//
// $('#accordion .panel-title').click(function () {
//     $(this).children('i').css('transform','rotate(90deg');
// });
$(document).ready(function () {
    let circles = [];

    let $circles_text = $('.circles-title');

    for (let i = 1; i < 5; ++i) {
        let child = document.getElementById('circles-' + i);
        let circle = Circles.create({
            id: child.id,
            radius: 75,
            value: child.dataset.language.replace(',','.'),
            maxValue: 100,
            text: function (value) {
                return value + '%';
            },
            width: 6,
            colors: ['rgba(255, 255, 255, .5)', 'rgba(194,23,30,0.7)'],
            textClass: 'circles-text',
        });

        circles.push(circle);

        $circles_text[i - 1].append(child.dataset.name);
    }
});

let list  = $('ul li');
for(let i=0; i < list.length; i++) {
    let html = `
 <div class="cd-timeline-block">
                    <div class="cd-timeline-img cd-picture"></div>
                    <div class="cd-timeline-content">
                        <h2>${list[i]}</h2>
                        <span class="cd-date">
                            {{  record.templatefields.type_of }} -
                            {{ loop.index }}
                        </span>
                    </div> <!-- cd-timeline-content -->
                </div> <!-- cd-timeline-block -->
`
}